export default "__VITE_ASSET__DPmgNXdb__"